<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent != null && localService.languageContent.table != undefined && source !== undefined && source !== null">
  <div class="banner center" style="max-width:1000px;">
    <div class="row row_header freeze_height">
      <div class="col-1">
        {{localService.languageContent.table.action}}
      </div>
      <div class="col-4">
        {{localService.languageContent.table.code}}
      </div>
      <div class="col-7">
        {{localService.languageContent.table.value}}
        <div class="icon_action_header">
          <i class="material-icons" (click)="openLanguageContent('')" title="{{localService.languageContent.common.add}}">note_add</i>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of source.items">
        <div class="col-1">
          <i class="material-icons button icon_adjust" title="{{item.v2 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v2 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v2 == '1' ? "toggle_on" : "toggle_off"}}</i>
        </div>
        <div class="col-4">
          <span class="button en" (click)="openLanguageContent(item.key)">{{item.v1}}</span>
        </div>
        <div class="col-7">
          {{item.v3}}
        </div>
      </div>
    </div>
  </div>
  <app-paging [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
